import React from 'react';

let Footer = () => {
    return (
        <div id='footer'>
            <p>coded and written by{' '}
                <a 
                href="https://github.com/emilekanaan" 
                target="_blank" 
                rel="noreferrer"
                
                >
                    Emile Kanaan
                </a>
            </p>
        </div>
    )
}

export default Footer;